import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "./Tooltip";

const CALENDLY_URL = "https://calendly.com/rosental/linkedin-contact";

const Contact = ({ classicHeader, darkTheme }) => {
  const [activeTab, setActiveTab] = useState("calendly");
  const calendlyRef = useRef(null);
  const calendlyInitialized = useRef(false);

  useEffect(() => {
    // Initialize Typeform embed
    if (window.tf) {
      window.tf.load();
    }
  }, []);

  useEffect(() => {
    // Initialize Calendly inline widget once the script has loaded
    if (calendlyInitialized.current) return;

    let attempts = 0;
    const tryInit = setInterval(() => {
      attempts += 1;
      if (window.Calendly && calendlyRef.current) {
        window.Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: calendlyRef.current,
        });
        calendlyInitialized.current = true;
        clearInterval(tryInit);
      } else if (attempts > 20) {
        clearInterval(tryInit);
      }
    }, 250);

    return () => clearInterval(tryInit);
  }, []);

  return (
    <section
      id="contact"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Contact
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Get in Touch
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* contact details */}
          <div className="col-md-4 col-xl-3 order-1 order-md-0 text-center text-md-start">
            <p className={"text-3 mb-4 " + (darkTheme ? "text-light" : "")}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-envelope" />
              </span>
              nic@nicrosental.com
            </p>
            <h2
              className={
                "mb-3 text-5 text-uppercase " + (darkTheme ? "text-white" : "")
              }
            >
              Follow Me
            </h2>
            <ul
              className={
                "social-icons justify-content-center justify-content-md-start " +
                (darkTheme ? "social-icons-muted" : "")
              }
            >
              <li className="social-icons-linkedin">
                <Tooltip text="LinkedIn" placement="top">
                  <a
                    href="https://linkedin.com/in/rosental"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin" />
                  </a>
                </Tooltip>
              </li>
              <li className="social-icons-github">
                <Tooltip text="Github" placement="top">
                  <a
                    href="http://www.github.com/nicdev"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github" />
                  </a>
                </Tooltip>
              </li>
            </ul>
          </div>
          {/* contact form */}
          <div className="col-md-8 col-xl-9 order-0 order-md-1">
            <h2
              className={
                "mb-3 text-5 text-uppercase text-center text-md-start " +
                (darkTheme ? "text-white" : "")
              }
            >
              Let's Chat
            </h2>

            {/* Contact method tabs */}
            <ul
              className={
                "nav nav-tabs justify-content-center justify-content-md-start mb-4 " +
                (darkTheme ? "nav-light" : "")
              }
            >
              <li className="nav-item">
                <button
                  className={
                    "nav-link " + (activeTab === "calendly" ? "active" : "")
                  }
                  onClick={() => setActiveTab("calendly")}
                >
                  <i className="far fa-calendar-alt me-2" />
                  Schedule a Call
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={
                    "nav-link " + (activeTab === "typeform" ? "active" : "")
                  }
                  onClick={() => setActiveTab("typeform")}
                >
                  <i className="far fa-envelope me-2" />
                  Send a Message
                </button>
              </li>
            </ul>

            {/* Calendly inline widget */}
            <div
              className={activeTab === "calendly" ? "d-block" : "d-none"}
            >
              <div
                ref={calendlyRef}
                style={{ minWidth: "280px", height: "1000px" }}
              ></div>
            </div>

            {/* Typeform embed */}
            <div className={activeTab === "typeform" ? "d-block" : "d-none"}>
              <div
                data-tf-live="01JNHJMC0WH2SVJ16ZNHA9X73Z"
                style={{ height: "600px" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
